module.exports = __webpack_public_path__ + "star2-27c9e0f27ba509189450889f20bbe813.png";